import { render, staticRenderFns } from "./EnDesarrollo.vue?vue&type=template&id=1f7745e9&scoped=true"
import script from "./EnDesarrollo.vue?vue&type=script&lang=js"
export * from "./EnDesarrollo.vue?vue&type=script&lang=js"
import style0 from "./EnDesarrollo.vue?vue&type=style&index=0&id=1f7745e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7745e9",
  null
  
)

export default component.exports